import { render, staticRenderFns } from "./JobsTableClientPaged.vue?vue&type=template&id=c98a0918"
import script from "./JobsTableClientPaged.vue?vue&type=script&lang=ts"
export * from "./JobsTableClientPaged.vue?vue&type=script&lang=ts"
import style0 from "./JobsTableClientPaged.vue?vue&type=style&index=0&id=c98a0918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports